import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import { ICardListItem, IFilterParams, ISelectList, ISelectWithTotal } from '../../interfaces';

export function useCardsSelect(): ISelectList {
    return useContext(MobXProviderContext).RootStore.cardsStore.select;
}

export function useCardsList(): ICardListItem[] {
    return useContext(MobXProviderContext).RootStore.cardsStore.cardsList;
}

export function useCardsFilterParams(): IFilterParams {
    const { filterParams } = useContext(MobXProviderContext).RootStore.cardsStore;

    return {
        ...filterParams,
        cardSetId: !useContext(MobXProviderContext).RootStore.profileStore.profile.isCompanyTypeIdMNOHost,
    };
}

export function useCardsSelectWithTotal(): ISelectWithTotal {
    const select = useContext(MobXProviderContext).RootStore.cardsStore.select;
    const total = useContext(MobXProviderContext).RootStore.cardsStore.totalSelect;
    return {
        select,
        total,
    };
}
